export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 md:pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50/60"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-5">
              <i className="ri-fire-line text-base"></i>
              <span>娱乐圈  ·  影视综  ·  电竞  ·  社会热点</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-tight mb-4">
              今日吃瓜 · 每日大赛与合集汇总平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              瓜料一站尽收，每日更新不停
            </p>

            <div className="space-y-3 text-foreground-700 text-sm md:text-base leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              <p>
                今日吃瓜是国内领先的娱乐资讯与热点话题聚合平台，专注为吃瓜爱好者提供最新、最全、最有趣的每日大赛与话题合集。我们覆盖娱乐圈、影视综艺、音乐现场、电竞游戏、社会热点等九大内容板块，通过全天候热点追踪与人工精选机制，确保每一条内容都值得细品。
              </p>
              <p>
                无论你是追星达人、综艺爱好者，还是热衷社会话题的理性讨论者，今日吃瓜都能让你一站式获取每日更新，轻松跟上每一天的热点节奏。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8 text-sm text-foreground-600">
              <div className="flex items-center gap-1.5">
                <i className="ri-refresh-line text-primary-500"></i>
                <span>每日更新<span className="text-primary-600 font-semibold ml-1">50+</span>条</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-stack-line text-primary-500"></i>
                <span>覆盖<span className="text-primary-600 font-semibold ml-1">9大</span>领域</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-user-smile-line text-primary-500"></i>
                <span><span className="text-primary-600 font-semibold">百万级</span>活跃读者</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
              >
                <i className="ri-flashlight-line"></i>
                立即浏览热点
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-background-300 text-foreground-700 font-semibold text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
              >
                <i className="ri-grid-line"></i>
                探索专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[300px] h-[380px] md:w-[380px] md:h-[480px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20dynamic%20collage%20style%20composition%20representing%20entertainment%20news%20and%20trending%20topics%2C%20warm%20coral%20and%20golden%20tones%2C%20abstract%20newspaper%20and%20social%20media%20elements%2C%20modern%20editorial%20design%2C%20bold%20graphic%20style%2C%20energetic%20atmosphere%2C%20clean%20background%20with%20soft%20gradients&width=760&height=960&seq=hero-main-01&orientation=portrait"
                alt="今日吃瓜 - 每日大赛与合集汇总平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2">
                  <span className="px-3 py-1 rounded-full bg-white/90 text-primary-700 text-xs font-semibold">🔥 实时热点</span>
                  <span className="px-3 py-1 rounded-full bg-white/90 text-foreground-700 text-xs font-semibold">📊 每日更新</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}